import { gql } from "@apollo/client";

export default gql`
  query getProfileOneononeQuery(
    $participants: [Int!]!
    $nextAfterDate: DateTime!
    $lastBeforeDate: DateTime!
  ) {
    nextOneonone: meetings(
      isFormalOneonone: true
      startDatetime_Gte: $nextAfterDate
      participants: $participants
      first: 1
      orderBy: "start_datetime"
    ) {
      edges {
        node {
          id
          startDatetime
          endDatetime
          title
          meetingGroupId
          topics {
            edges {
              node {
                id
                title
                state
                canDelete {
                  permission
                }
              }
            }
          }
        }
      }
    }

    lastOneonone: meetings(
      isFormalOneonone: true
      startDatetime_Lt: $lastBeforeDate
      participants: $participants
      first: 1
      orderBy: "-start_datetime"
    ) {
      edges {
        node {
          id
          startDatetime
          endDatetime
          title
          meetingGroupId
          transcript {
            id
            summary
          }
          topics {
            edges {
              node {
                id
                title
                state
              }
            }
          }
        }
      }
    }

    candidateMeetings: meetings(
      participants: $participants
      participantCount: 2
      isFormalOneonone: false
      startDatetime_Gte: $nextAfterDate
      first: 20
      orderBy: "start_datetime"
    ) {
      edges {
        node {
          id
          title
          startDatetime
          meetingGroupId
        }
      }
    }
  }
`;
